var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuListOtherFacilities(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,0C5.383,0,0,5.383,0,12c.603,15.898,23.4,15.894,24,0,0-6.617-5.383-12-12-12Zm0,21c-4.963,0-9-4.037-9-9,.452-11.923,17.549-11.92,18,0,0,4.963-4.037,9-9,9Zm4-6.587c0,1.599-1.052,2.957-2.5,3.418v.669c-.034,1.972-2.966,1.971-3,0v-.579c-.955-.206-1.799-.807-2.299-1.67-.414-.717-.169-1.635,.548-2.05,.716-.414,1.634-.169,2.05,.548,.091,.157,.253,.251,.434,.251h1.181c.629,.018,.809-.917,.218-1.132l-2.376-.95c-3.11-1.155-2.884-5.845,.245-6.749v-.669c.034-1.972,2.967-1.971,3,0v.579c.955,.206,1.799,.807,2.299,1.67,.414,.717,.169,1.635-.548,2.049-.716,.414-1.635,.169-2.05-.547-.091-.157-.253-.251-.434-.251h-1.181c-.629-.018-.809,.917-.218,1.132l2.376,.95c1.37,.548,2.255,1.855,2.255,3.331Z",
    fill: "#246abf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuListOtherFacilities);
export default __webpack_public_path__ + "static/media/menu_list-other_facilities.c1972969ae97dd6d5d6b3e13f00022e6.svg";
export { ForwardRef as ReactComponent };